import { type BracketRound } from '@terros/common'
import { DateTime, Interval } from 'luxon'

export const getCurrentRound = <T extends Pick<BracketRound, 'startDate' | 'endDate'>>(rounds: T[]): T | undefined => {
  const now = DateTime.now()
  return rounds.find((r) => {
    const interval = getRoundInterval(r)
    return interval.contains(now)
  })
}

export const getRoundInterval = (round: Pick<BracketRound, 'startDate' | 'endDate'>): Interval => {
  return Interval.fromDateTimes(DateTime.fromMillis(round.startDate), DateTime.fromMillis(round.endDate))
}
